import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';

import { createRoute } from 'lib/util';

export const CostCentersForm = ({
  company,
  errors,
  handleAddYear,
  handleRemoveYear,
  handleSubmit,
  handleValueChange,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSaving,
  isSubmitted,
  subcompany,
  t,
  values,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <div className="col-md-12 mt-3">
        <div className="row align-items-center">
          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Form.FieldInput
              error={(isSubmitted && errors.key) || {}}
              name={'key'}
              label={t('costCenters.fields.key')}
              handleChange={handleValueChange}
              t={t}
              value={values.key}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Form.FieldInput
              error={(isSubmitted && errors.name) || {}}
              name={'name'}
              label={t('costCenters.fields.name')}
              handleChange={handleValueChange}
              t={t}
              value={values.name}
            />
          </div>
          <div className="col-sm-12">
            <Form.FieldTextArea
              error={(isSubmitted && errors.description) || {}}
              name={'description'}
              label={t('costCenters.fields.description')}
              handleChange={handleValueChange}
              t={t}
              value={values.description}
            />
          </div>

          {/* Groups */}
          <Form.CustomFields
            errors={errors}
            handleCustomFieldChange={handleCustomFieldChange}
            handleGroupChange={handleGroupChange}
            isSubmitted={isSubmitted}
            t={t}
            values={values}
            groups={groups}
          ></Form.CustomFields>
          {/* Groups */}
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={createRoute(company.id, subcompany.id, `cost_centers`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    key: {
      type: 'string',
      minLength: 1,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    description: {
      type: 'string',
      minLength: 1,
    },
  },
  required: ['key', 'name', 'description'],
})(translate()(CostCentersForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/form/CostCenterForm.js